import Cashes from "../Reports/Cashes";

export default function Accounts() {
  return <Cashes />;
}
